import React from 'react';
import { FunctionData } from '@hud/portal-dtos/webapp-function.dto';
import DataColumns from '@hud/web-components/DataColumns/DataColumns';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { formatDateTime } from '@hud/web-components/utils';
import { EntitiesPopover } from '../../../components/EntitiesPopover/EntitiesPopover';
import { RuntimeLabel } from '@hud/web-components/Runtime/RuntimeLabel';
import { ModuleLabel } from '@hud/web-components/ThirdParty/ModuleLabel';
import { OverviewContainer } from './FunctionOverview.styles';

export interface FunctionOverviewProps {
  function?: FunctionData;
  loading: boolean;
}

export default function FunctionOverview({
  function: func,
  loading,
}: FunctionOverviewProps) {
  return (
    <OverviewContainer variant="filled" title="Details" icon="webviewMenu.info">
      <DataColumns.WrappableColumns>
        <DataColumns.Column>
          <DataColumns.Row loading={loading} title="Path">
            <LongContentPopover reverseEllipsis copyable copyButtonSize="xs">
              {func?.filePath}
            </LongContentPopover>
          </DataColumns.Row>

          <DataColumns.Row loading={loading} title="Language">
            {func?.runtime ? <RuntimeLabel runtime={func.runtime} /> : null}
          </DataColumns.Row>

          <DataColumns.Row loading={loading} title="Services">
            {func?.services ? (
              <EntitiesPopover entityType="services" entities={func.services} />
            ) : null}
          </DataColumns.Row>
          {func?.thirdPartyModule && (
            <DataColumns.Row loading={loading} title="3rd party lib">
              <ModuleLabel module={func.thirdPartyModule} />
            </DataColumns.Row>
          )}
        </DataColumns.Column>

        <DataColumns.Column>
          <DataColumns.Row loading={loading} title="First mapped">
            {func?.firstSeenAt ? formatDateTime(func.firstSeenAt, true) : '-'}
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Last tracked invocation">
            {func?.lastInvokedAt
              ? formatDateTime(func.lastInvokedAt, true)
              : '-'}
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Last change">
            {func?.lastChangeAt ? formatDateTime(func.lastChangeAt, true) : '-'}
          </DataColumns.Row>
        </DataColumns.Column>
      </DataColumns.WrappableColumns>
    </OverviewContainer>
  );
}
